import { render, staticRenderFns } from "./tempItem.vue?vue&type=template&id=de4212a2&scoped=true"
import script from "./tempItem.vue?vue&type=script&lang=js"
export * from "./tempItem.vue?vue&type=script&lang=js"
import style0 from "./tempItem.vue?vue&type=style&index=0&id=de4212a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4212a2",
  null
  
)

export default component.exports